import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from  "../../Services/api";
import "./index.css";
import LogoPalmares from "../../Imagens/logoWhite.png";
import 'bootstrap/dist/css/bootstrap.min.css';

const Index = () => {
  
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");

  useEffect(function () {
    localStorage.removeItem("usuarioLogado"); 
  }, []);

  async function ValidaUsuario(){   
    localStorage.removeItem("usuarioLogado"); 
    let retorno = await buscaUsuario();
    
    if(retorno.status === 200){
      if (retorno.data.Usuario.tipo === 0){
        localStorage.setItem("usuarioLogado",JSON.stringify(retorno.data.Usuario));
        if (localStorage.getItem("usuarioLogado") === null) {
          console.log('Não Entrou !!!');
        }else{
          console.log(retorno.data.Usuario);
          console.log('Usuario Logado!');
          navigate("/Menu");
        }
      } else{
        document.getElementById('msm_senha').innerText = 'Usuário sem permissão de acesso!';
        document.getElementById('msm_senha').style.display = 'block';
      }
    }else{
      document.getElementById('msm_senha').innerText = 'Usuário e senha não conferem!';
      document.getElementById('msm_senha').style.display = 'block';
    }
  }

  async function buscaUsuario(){      
    
    let formData = new FormData();

    formData.append('login', usuario);
    formData.append('senha', password);
    
    try {
      const response = await api.post('/usuario/login', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return (
    <div className="TelaLoginInicial" align="center">
      <div id="painelLOGO" >
        <img style={{width: '100%'}} src={LogoPalmares} alt="Logo Grupo Palmares"></img>
      </div>
      <div className="PainelLogin">
          <div className="login-container p-5 shadow">
            <form>
              <div className="form-group mb-3" align="left">
                <label htmlFor="usuario" className="form-label">Usuário:</label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="usuario"
                  placeholder="Digite seu usuário"
                  style={{textAlign: "center"}}
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                />
              </div>
              <div className="form-group mb-4" align="left">
                <label htmlFor="senha" className="form-label">Senha:</label>
                <input
                  type="password"
                  className="form-control form-control-lg"
                  id="senha"
                  placeholder="Digite sua senha"
                  style={{textAlign: "center"}}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      ValidaUsuario();
                    }
                  }}
                />
              </div>
              <button type="button" className="btn btn-primary btn-lg w-100" onClick={() => ValidaUsuario()}>ENTRAR</button>
              <label id="msm_senha">Usuário e senha não conferem!</label>
            </form>
          </div>
        </div> 
      </div>

  );
};

export default Index;